import { axiosClient, axiosClientSuperStudent, axiosRecap } from "./axiosClient";
import { ENDPOINTS } from "./endpopints";

export const fetchCitybyMaster = () => {
  return axiosClient.get(ENDPOINTS.city);
};

export const fetchTeacher = () => {
  return axiosClient.get(ENDPOINTS.listTeacher);
};

export const fetchRecap = () => {
  return axiosRecap.get(ENDPOINTS.recap);
};

export const fetchBizdevJob = () => {
  const formData = new FormData();
  formData.append('jobdesk', JSON.stringify(['JD004', 'JD017', 'JD007', 'JD028', 'JD030']))

  return axiosClientSuperStudent.post(ENDPOINTS.bizdev, formData);
};

export const fetchTypeByCity = (_selectedCityId) => {
  const formData = new FormData();
  formData.append('id_area', _selectedCityId);
  return axiosClient.post(ENDPOINTS.type, formData);
};

export const fetchProgramByType = (_selectedCityId, _selectedLearningType) => {
  const formData = new FormData();
  formData.append('id_area', _selectedCityId);
  formData.append('schedule', _selectedLearningType);
  return axiosClient.post(ENDPOINTS.program, formData);
};

export const fetchClassByProgram = (_selectedCityId, _selectedLearningType, _selectedProgram) => {
  const formData = new FormData();
  formData.append('id_area', _selectedCityId);
  formData.append('schedule', _selectedLearningType);
  formData.append('id_program', _selectedProgram);
  return axiosClient.post(ENDPOINTS.classMeets, formData);
};

export const fetchPriceByType = (data) => {
  return axiosClient.post(ENDPOINTS.payment, data);
};

export const fetchMemberByEmail = (_inputEmail) => {
  return axiosClient.get(ENDPOINTS.member + _inputEmail);
};

export const setMemberStatusByEmail = (
  _selectedProgram,
  _selectedClassMeet,
  _selectedCityId,
  _selectedLearningType,
  result,
  _statusPayment,
  _student
) => {
  const formData = new FormData();
  formData.append('id_program', _selectedProgram);
  formData.append('id_type', _selectedClassMeet);
  formData.append('id_area', _selectedCityId);
  formData.append('schedule', _selectedLearningType);

  if (result.status_payment === "N") {
    formData.append("non_member", "none");
  }

  return axiosClient.post(ENDPOINTS.payment, formData);

};

export const checkPromoByCode = (
  _selectedProgram,
  _selectedClassMeet,
  _selectedCityId,
  _selectedLearningType,
  _inputPromoCode
) => {
  const formData = new FormData();
  formData.append('id_program', _selectedProgram);
  formData.append('id_type', _selectedClassMeet);
  formData.append('id_area', _selectedCityId);
  formData.append('schedule', _selectedLearningType);
  formData.append("non_member", "none");
  formData.append('code_voucher', _inputPromoCode);

  return axiosClient.post(ENDPOINTS.payment, formData);
};

export const fetchRegister = (
  _typeCourse,
  _inputFirstName,
  _inputLastName,
  _inputPhone,
  _inputEmail,
  _inputAddress,
  _selectedProgram,
  _selectedLearningType,
  _selectedClassMeet,
  _selectedMeetWeekly,
  _midtransPrice,
  _selectedCityId,
  _selectedBizdev,
  _inputPromoCode,
  _duration,
  formattedSchedules,
  _reasons,
  _other,
  _ielts,
  _inputReferalCode,
  _teacherList,
  exam_depart
) => {
  const formData = new FormData();
  //apakah 'id_teacher' perlu di send juga ???
  formData.append('type_class', _typeCourse);
  formData.append('first_name', _inputFirstName);
  formData.append('last_name', _inputLastName);
  formData.append('no_wa', _inputPhone);
  formData.append('email', _inputEmail);
  formData.append('alamat', _inputAddress);
  formData.append('id_program', _selectedProgram);
  formData.append('selectedSchedule', _selectedLearningType);
  formData.append('id_type', _selectedClassMeet);
  formData.append('class_meet_weekly', _selectedMeetWeekly);
  formData.append('harga', _midtransPrice);
  formData.append('id_kabkota', _selectedCityId);
  formData.append("recomender", _selectedBizdev);
  formData.append("duration", _duration);
  formData.append("schedules", formattedSchedules);
  if (_ielts) {
    formData.append("reasons", `${_reasons} (target IELTS: ${_ielts})`);
  } else if (_other) {
    formData.append("reasons", `${_reasons}: ${_other}`);
  }
  else {
    formData.append("reasons", _reasons);
  }
  formData.append('referal_code', _inputReferalCode);
  // if (_teacherList) formData.append('id_teacher', _teacherList); // hanya jika ada
  formData.append("exam", exam_depart);

  let urlEndPoint = _typeCourse === "t" ? ENDPOINTS.free : ENDPOINTS.normal;

  return axiosClient.post(urlEndPoint, formData);
};